export * from './static-page';
export * from './use-static-page';
